import { useEffect, useState } from 'react';
import { isStoredEmployeeInactive, EMPLOYEE_STATUS_CHANGED_EVENT } from '../utils/apiClient';

// Whether the logged-in employee's account is "Inactive" (limited to Payslips and Tickets).
// Read from the stored session and re-read whenever apiClient/App.js update the status.
export default function useIsInactiveEmployee() {
  const [isInactive, setIsInactive] = useState(isStoredEmployeeInactive);

  useEffect(() => {
    const refresh = () => setIsInactive(isStoredEmployeeInactive());
    window.addEventListener(EMPLOYEE_STATUS_CHANGED_EVENT, refresh);
    return () => window.removeEventListener(EMPLOYEE_STATUS_CHANGED_EVENT, refresh);
  }, []);

  return isInactive;
}
